import type { WallPost } from "../../api/content";
import { isPhotoItem } from "../../player";
import { shownImage } from "../../lib/externalMedia";

/**
 * First photo, else a video's or a link's thumbnail (spec 4 §2.2). Privacy consent: `externalAllowed` (external_media
 * ACCEPTED on this browser) is required, so no caller can skip it — a third-party thumbnail (YouTube, SoundCloud …)
 * is skipped until then and the next own picture is used; null → the caller's neutral block. Pass true only to store
 * the raw value (recent plays), never to render it.
 */
export function uploadThumb(p: WallPost, externalAllowed: boolean): string | null {
  for (const it of p.items) {
    const url = shownImage(isPhotoItem(it) ? it.photoUrl : it.thumbnailUrl, externalAllowed);
    if (url) return url;
  }
  return null;
}

/** The title, else the caption's first line, else the first item title; "" when none. */
export function uploadTitle(p: WallPost): string {
  const title = p.title?.trim();
  if (title) return title;
  const line = (p.caption ?? "").split("\n").map((s) => s.trim()).find(Boolean);
  if (line) return line;
  return p.items.map((it) => it.title?.trim() ?? "").find(Boolean) ?? "";
}
